import HttpClienteToken from '../../services/HttpClientToken';

import { AutoridadAmparoProps } from '../../interfaces/catalogos/AutoridadAmparoInterface';

export const AutoridadAmparo = () => {

    return new Promise<AutoridadAmparoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/AutoridadAmparo/', token)
            .then( ({ data } : { data : AutoridadAmparoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAutoridadAmparo = () => {

    return new Promise<AutoridadAmparoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/AutoridadAmparo/ObtenerAutoridadAmparo', token)
            .then( ({ data } : { data : AutoridadAmparoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarAutoridadAmparo = ( params: AutoridadAmparoProps ) => {

    return new Promise<AutoridadAmparoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AutoridadAmparo/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadAmparoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridadAmparo: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarAutoridadAmparo = ( params: AutoridadAmparoProps ) => {

    return new Promise<AutoridadAmparoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/AutoridadAmparo/Agregar', params, token)
            .then( ({ data } : { data : AutoridadAmparoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridadAmparo: 0,                 
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}